import { BPaymentBehaviourEnum } from '@/types/temp';
export const INITIAL_CART_CONTEXT = {
    /* create reservation */
    addToCart: null,
    /* reservation in progress */
    reservationInProgress: null,
    setReservationInProgress: null,
    // OLD
    loadingCart: false,
    /* discount */
    applyDiscount: null,
    removeDiscount: null,
    discountCodeError: false,
    resetDiscountCodeError: null,
    /* reservationSpecialRequest */
    specialRequest: null,
    setSpecialRequest: null,
    /* user info */
    isContactFormDisabled: false,
    email: null,
    firstName: null,
    lastName: null,
    optInEstablishments: false,
    phoneNumber: null,
    phoneCountry: null,
    setFirstName: null,
    setLastName: null,
    setEmail: null,
    setPhoneNumber: null,
    setPhoneCountry: null,
    setOptInEstablishments: null,
    firstNameError: null,
    lastNameError: null,
    emailError: null,
    phoneError: null,
    creditCardError: null,
    setIsFirstNameInError: null,
    setIsLastNameInError: null,
    setIsEmailInError: null,
    setIsPhoneInError: null,
    setIsCreditCardInError: null,
    /* cart validation */
    validateCart: null,
    /* main btn label */
    mainButtonLabel: null,
    /* price */
    calculatedPrice: null,
    paymentBehaviour: BPaymentBehaviourEnum.Checkout,
    discount: null,
    totalPrice: null,
    conversionAmount: null,
    totalPriceLabel: null,
    totalPriceText: null,
    totalPriceBeforeDiscountLabel: null,
    totalPriceBeforeDiscountText: null
};
